import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getUser } from "./api/auth";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!getUser()); // Check if user is logged in (non-null user from auth.js)

  // Update authentication state when storage changes
  useEffect(() => {
    const checkAuth = () => {
      setIsAuthenticated(!!getUser());
    };

    // Check auth on mount
    checkAuth();

    // Listen for storage changes (in case login happens in another tab)
    window.addEventListener("storage", checkAuth);

    // Listen for custom auth state change events
    window.addEventListener("authStateChanged", checkAuth);

    // Also check periodically in case cookies are updated
    const interval = setInterval(checkAuth, 1000);

    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("authStateChanged", checkAuth);
      clearInterval(interval);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
